export type FatigueLevel = 'critical' | 'high' | 'elevated' | 'low'

export const FATIGUE_LEVEL_COLORS: Record<FatigueLevel, string> = {
  critical: '#E74C3C',
  high: '#F4D03F',
  elevated: '#F97316',
  low: '#8A8A8A',
}

export const FATIGUE_LEVEL_LABELS: Record<FatigueLevel, string> = {
  critical: 'Critical',
  high: 'High',
  elevated: 'Elevated',
  low: 'Low',
}

export interface IFatigueRow {
  id: number
  level: FatigueLevel
  name: string
  role: string
  siteId: number
  departmentId: number
  index: number
  hours7d: number
  consecutiveDays: number
  overrideActive: boolean
}
